import React from 'react';
import PropTypes from 'prop-types';

import { toInitials, colorFromName } from '../utils/generatedAvatar';
const CommunityIcon = ({ className, name }) => {
    return (
        <svg
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid meet"
            role="img"
            aria-label={name}
            className={className}
        >
            <rect width="100%" height="100%" fill={colorFromName(name)} />

            <text
                x="50%"
                y="50%"
                fontSize="50"
                textAnchor="middle"
                dominantBaseline="central"
                dy="-0.05em"
                fill="white"
            >
                {toInitials(name)}
            </text>
        </svg>
    );
};

CommunityIcon.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
};

export default CommunityIcon;
